//place custom scripts for admin

// Doubleclick logic for table rows
$('.dbl-clickable').dblclick(function (event) {
    window.location.href = $(event.target.closest('tr')).attr('data-dblclick');
});
